module.exports = __webpack_public_path__ + "img/click_tab1_mobile.fcf5a5be.png";